// 处理数据 后端返回来的月份会缺少 前端动态处理
export function handleMonthData(begin, end, list, type) {
    var array = [];
    var beginYear = begin.substring(0, 4);
    var endYear = end.substring(0, 4);
    var beginMonth = begin.substring(begin.length - 2, begin.length);
    var endMonth = end.substring(end.length - 2, end.length);
    if (beginYear === endYear) {
        // 如果是同一年
        for (let i = Number(beginMonth); i < Number(endMonth) + 1; i++) {
            var month = i;
            if (i < 10) {
                month = "0" + i;
            }
            array.push(beginYear + "-" + month);
        }
    } else {
        var subYear = Number(endYear) - Number(beginYear);
        for (let i = 0; i < subYear + 1; i++) {
            var judgeBeginMonth = 0;
            var judgeEndMonth = 0;

            if (i === 0) {
                judgeBeginMonth = Number(beginMonth);
                judgeEndMonth = 13;
            } else if (i === subYear) {
                judgeBeginMonth = 1;
                judgeEndMonth = Number(endMonth) + 1;
            } else {
                judgeBeginMonth = 1;
                judgeEndMonth = 13;
            }
            for (let j = judgeBeginMonth; j < judgeEndMonth; j++) {
                var month = j;
                if (j < 10) {
                    month = "0" + j;
                }
                array.push(Number(beginYear) + i + "-" + month);
            }
        }
    }
    // 返回echart格式的数据

    if (type === "dkNow") {
        var echartData = {
            xLineList: [],
            dataList: [],
        };
        echartData.xLineList = array;
        array.forEach((item) => {
            echartData.dataList.push({
                name: item,
                value: 0,
            });
        });
        echartData.dataList.forEach((item) => {
            list.forEach((item1) => {
                if (item.name === item1.month) {
                    item.value = item1.beginBillingAmount;
                }
            });
        });
        return echartData;
    }

    if (type === "dkDown") {
        var echartData = {
            xLineList: [],
            upDataList: [],
            reDataList: [],
        };
        echartData.xLineList = array;
        array.forEach((item) => {
            echartData.upDataList.push({
                name: item,
                value: 0,
            });
            echartData.reDataList.push({
                name: item,
                value: 0,
            });
        });
        echartData.upDataList.forEach((item) => {
            list.forEach((item1) => {
                if (item.name === item1.month) {
                    item.value = item1.beginBillingAmount;
                }
            });
        });
        echartData.reDataList.forEach((item) => {
            list.forEach((item1) => {
                if (item.name === item1.month) {
                    item.value = item1.stopBillingAmount;
                }
            });
        });
        return echartData;
    }
}
// 处理数据 后端返回来的日期会缺少 前端动态处理
export function handleDayData(begin, end, list, type) {
    let beginTimeStamp = new Date(begin.replace(/-/g, '/')).getTime()
    let endTimeStamp = new Date(end.replace(/-/g, '/')).getTime()
    let subTimeStamp = (endTimeStamp - beginTimeStamp) / (1000 * 60 * 60 * 24)
    var array = [];
    for (let i = subTimeStamp; i >= 0; i--) {
        var newDate = new Date(endTimeStamp - 1000 * 60 * 60 * 24 * i);
        var lastY = newDate.getFullYear();
        var lastM = newDate.getMonth() + 1;
        var lastD = newDate.getDate();
        var LDate = lastY + "-" + (lastM < 10 ? "0" + lastM : lastM) + "-" + (lastD < 10 ? "0" + lastD : lastD); // 得到30天前的时间
        array.push(LDate)
    }
    if (type === "dkNow") {
        var echartData = {
            xLineList: [],
            upDataList: [],
            reDataList: [],
        };
        echartData.xLineList = array;
        array.forEach((item) => {
            echartData.upDataList.push({
                name: item,
                value: 0,
            });
            echartData.reDataList.push({
                name: item,
                value: 0,
            });
        });
        echartData.upDataList.forEach((item) => {
            list.forEach((item1) => {
                if (item.name === item1.date) {
                    item.value = item1.beginBillingAmount;
                }
            });
        });
        echartData.reDataList.forEach((item) => {
            list.forEach((item1) => {
                if (item.name === item1.date) {
                    item.value = item1.stopBillingAmount;
                }
            });
        });
    }
    if (type === "dkDown") {
        var echartData = {
            xLineList: [],
            deliverInList: [],
            deliverOutList: [],
            reDataList: [],
        };
        echartData.xLineList = array;
        array.forEach((item) => {
            echartData.deliverInList.push({
                name: item,
                value: 0,
            });
            echartData.deliverOutList.push({
                name: item,
                value: 0,
            });
            echartData.reDataList.push({
                name: item,
                value: 0,
            });
        });
        echartData.deliverInList.forEach((item) => {
            list.forEach((item1) => {
                if (item.name === item1.date) {
                    item.value = item1.deliverInAmount;
                }
            });
        });
        echartData.deliverOutList.forEach((item) => {
            list.forEach((item1) => {
                if (item.name === item1.date) {
                    item.value = item1.deliverOutAmount;
                }
            });
        });
        echartData.reDataList.forEach((item) => {
            list.forEach((item1) => {
                if (item.name === item1.date) {
                    item.value = item1.stopBillingAmount;
                }
            });
        });
    }
    return echartData;
}
// 时间选择器 默认值 获取前12个月的时间
export function handleBeforeYear() {
    var data = new Date();
    var dataArr = [];
    var month = data.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    dataArr.push(data.getFullYear() + "-" + month); // 当前月份
    data.setMonth(data.getMonth() - 12); // 前12个月
    month = data.getMonth() + 1;
    month = month < 10 ? "0" + month : month;
    dataArr.push(data.getFullYear() + "-" + month);
    return dataArr;
}
// 时间选择器 默认值 获取前30天时间
export function handleBefore30Day() {
    var dataArr = [];
    //获取当前日期
    var date = new Date();
    var year = date.getFullYear();
    var month = date.getMonth() + 1;
    var day = date.getDate();
    var nowDate = year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
    dataArr.push(nowDate)
        //获取30天前得日期
    var lastDate = new Date(date - 1000 * 60 * 60 * 24 * 30); //最后30天可以更改，意义：是获取多少天前的时间
    var lastY = lastDate.getFullYear();
    var lastM = lastDate.getMonth() + 1;
    var lastD = lastDate.getDate();
    var LDate = lastY + "-" + (lastM < 10 ? "0" + lastM : lastM) + "-" + (lastD < 10 ? "0" + lastD : lastD); //得到30天前的时间
    dataArr.push(LDate)
    return dataArr;
}
// 分割数组 每个swiper 5行
export function sliceGroup(array, subGroupLength) {
    let index = 0;
    let newArray = [];
    while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
    }
    return newArray;
}
// 时间选择器快捷操作
export function shortcuts() {
    var arr = [{
            text: "过往30天",
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "过往90天",
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "过往180天",
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "过往365天",
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "上周",
            onClick(picker) {
                const oDate = new Date();
                oDate.setTime(oDate.getTime() - 3600 * 1000 * 24 * 7);

                var day = oDate.getDay();

                var start = new Date(),
                    end = new Date();
                if (day == 0) {
                    start.setDate(oDate.getDate());
                    end.setDate(oDate.getDate() + 6);
                } else {
                    start.setTime(oDate.getTime() - 3600 * 1000 * 24 * day);
                    end.setTime(oDate.getTime() + 3600 * 1000 * 24 * (6 - day));
                }

                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "本周",
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                var thisDay = start.getDay();
                var thisDate = start.getDate();
                if (thisDay != 0) {
                    start.setDate(thisDate - thisDay);
                }
                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "上月",
            onClick(picker) {
                const oDate = new Date();
                var year = oDate.getFullYear();
                var month = oDate.getMonth();
                var start, end;
                if (month == 0) {
                    year--;
                    start = new Date(year, 11, 1);
                    end = new Date(year, 11, 31);
                } else {
                    start = new Date(year, month - 1, 1);
                    end = new Date(year, month, 0);
                }

                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "本月",
            onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setDate(1);
                picker.$emit("pick", [start, end]);
            },
        },
        {
            text: "本季度",
            onClick(picker) {
                var oDate = new Date();

                var thisYear = oDate.getFullYear();
                var thisMonth = oDate.getMonth() + 1;

                var n = Math.ceil(thisMonth / 3); // 季度

                var Month = n * 3 - 1;

                var start = new Date(thisYear, Month - 2, 1);
                var end = new Date();

                picker.$emit("pick", [start, end]);
            },
        },

        {
            text: "去年",
            onClick(picker) {
                var oDate = new Date();
                var prevYear = oDate.getFullYear() - 1;
                const end = new Date();
                const start = new Date();
                start.setFullYear(prevYear);
                start.setMonth(0);
                start.setDate(1);

                end.setFullYear(prevYear);
                end.setMonth(11);
                end.setDate(31);

                picker.$emit("pick", [start, end]);
            },
        },
    ]
    return {
        shortcuts: arr
    }
}